<!-- Answers: which games were played most in the selected timeline. -->
<template>
    <dashboard-panel title="Most played games" subtitle="Only games with at least 1 booking (named experience)">
        <dashboard-doughnut-chart-host :labels="donutLabels" :data="donutData" />
        <div class="ranking-list">
            <div v-for="game in topGames" :key="`count-${game.name}`">
                <span>{{ game.name }}</span>
                <span>{{ game.count }} ({{ game.percentage }}%)</span>
            </div>
        </div>
    </dashboard-panel>
</template>

<script setup>
import { computed } from "vue";
import DashboardDoughnutChartHost from "./DashboardDoughnutChartHost.vue";
import DashboardPanel from "./DashboardPanel.vue";

const props = defineProps({
    topGames: {
        type: Array,
        default: () => [],
    },
});

const topSixGames = computed(() => props.topGames.slice(0, 6));
const donutLabels = computed(() => topSixGames.value.map((item) => item.name));
const donutData = computed(() => topSixGames.value.map((item) => item.count));
</script>

<style scoped>
.ranking-list {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    margin-top: var(--s-3);
    font-size: 14px;
}

.ranking-list div {
    display: flex;
    justify-content: space-between;
    gap: 0.75rem;
    border-bottom: 1px solid var(--line);
    padding-bottom: 0.3rem;
}
</style>
